import { createHTTPClient } from "@airhelp/http-client";
import { caller, valid, queryStringAddon, snakeCaseBody } from "@airhelp/http-client/addons";
import { A as ActivationStatus, P as ProductName, M as MembershipTier, T as TripTier } from "./enums-CvGYFxTm.js";
import { i, j, g, c, f, e, d, B, C, F, I, a, h, b } from "./enums-CvGYFxTm.js";
import { ah, ag, M, O, N, J, L, K, F as F2, G, I as I2, H, B as B2, R, Q, V, _, am, ak, al, s, a7, a6, ac, ab, ad, af, ae, y, P, aj, ai, o, l, n, k, i as i2, j as j2, ar, $, a5, a4, d as d2, c as c2, a1, a0, a3, a2, h as h2, e as e2, g as g2, b as b2, a as a8, f as f2, aq, ap, T, S, U, D, C as C2, E, z, m, A, Y, x, v, w, Z, p, t, ao, an, q, u, av, au, as, at, ax, aw, aa, a9, a8 as a82, r, X, W } from "./update-credit-card-BfU9Y0n1.js";
import { z as z2 } from "zod";
const validateActivationTokenResponseSchema = z2.object({
  activationStatus: z2.nativeEnum(ActivationStatus),
  email: z2.string(),
  resetPasswordToken: z2.string()
});
const validateActivationTokenRequestSchema = z2.object({
  tripUuid: z2.string(),
  token: z2.string()
});
function validateActivationToken({
  client,
  params
}) {
  const { tripUuid, token } = validateActivationTokenRequestSchema.parse(params);
  return client.url(`/api/v2/trips/${tripUuid}/validate_activation_token`).post({ token }).valid(validateActivationTokenResponseSchema);
}
const activateTripRequestSchema = z2.object({
  tripUuid: z2.string(),
  token: z2.string()
});
function activateTrip({
  client,
  params
}) {
  const { tripUuid, token } = activateTripRequestSchema.parse(params);
  return client.url(`/api/v2/trips/${tripUuid}/activate`).post({ token }).res();
}
const dashboardSchema = z2.object({
  canAddFellowPassengersToFlight: z2.boolean(),
  canAddTrip: z2.boolean(),
  loungesPerkEnabled: z2.boolean(),
  dashboardVisited: z2.boolean(),
  personalDetailsProvided: z2.boolean(),
  upsellEnabled: z2.boolean()
});
const benefitsSchema = z2.object({
  airLuggagePayout: z2.number().nullable(),
  airLuggageMaxBags: z2.number().nullable(),
  airLuggageTokens: z2.number().nullable(),
  airLuggageUnlimited: z2.boolean().nullable(),
  airLuggageIncluded: z2.boolean().nullable(),
  airPayoutPayout: z2.number(),
  airPayoutTokens: z2.number(),
  airPayoutUnlimited: z2.boolean(),
  airPayoutIncluded: z2.boolean(),
  loungeAccessEnabled: z2.boolean(),
  loungeAccessUnlimited: z2.boolean(),
  loungeAccessTokens: z2.number(),
  journeyLoungeAccessEnabled: z2.boolean(),
  journeyLoungeAccessTokens: z2.number(),
  journeyLoungeAccessUnlimited: z2.boolean(),
  journeyLoungeAccessCommunicatedDepartureThresholdHours: z2.number(),
  loungeAccessCommunicatedDepartureThresholdHours: z2.number(),
  departureThresholdHours: z2.number(),
  freeCompensationIncluded: z2.boolean()
});
const membershipSchema = z2.object({
  active: z2.boolean(),
  autoRenewal: z2.boolean(),
  canceled: z2.boolean(),
  displayName: z2.string(),
  endDate: z2.string(),
  fromCustomer: z2.boolean(),
  onGracePeriod: z2.boolean(),
  productName: z2.nativeEnum(ProductName).or(z2.string()),
  startDate: z2.string(),
  tier: z2.nativeEnum(MembershipTier),
  paymentMethodAttached: z2.boolean()
});
const carRentalSchema = z2.object({
  code: z2.string(),
  discount: z2.number()
});
const fastTrackSchema = z2.object({
  code: z2.string(),
  discount: z2.number()
});
const loungePassSchema$1 = z2.object({
  discount: z2.number()
});
const esimSchema = z2.object({
  code: z2.string(),
  discount: z2.number(),
  type: z2.string()
});
const perksSchema = z2.object({
  esim: esimSchema.nullable(),
  carRental: carRentalSchema.nullable(),
  airportTransfer: z2.object({}).nullable(),
  fastTrack: fastTrackSchema.nullable(),
  loungePass: loungePassSchema$1.nullable()
});
const coverageSchema = z2.object({
  active: z2.boolean(),
  covered: z2.boolean(),
  expired: z2.boolean()
});
const tripSchema = z2.object({
  active: z2.boolean(),
  partnerSlug: z2.string().nullable(),
  tier: z2.nativeEnum(TripTier).nullable()
});
const userPolicySchema = z2.object({
  benefits: benefitsSchema.nullable(),
  coverage: coverageSchema,
  dashboard: dashboardSchema,
  membership: membershipSchema.nullable(),
  trip: tripSchema.nullable(),
  perks: perksSchema.nullable()
});
const consentsSchema = z2.object({
  marketingConsent: z2.boolean(),
  whatsappConsent: z2.boolean(),
  flightNotificationsConsent: z2.boolean().optional().nullable()
});
const baseConsentsSchema = z2.object({
  consents: consentsSchema
});
const fetchConsentsResponseSchema = baseConsentsSchema;
const updateConsentsRequestSchema = consentsSchema;
const updateConsentsResponseSchema = baseConsentsSchema;
const userProfileSchema = z2.object({
  consents: consentsSchema,
  email: z2.string().email(),
  firstName: z2.string().nullable(),
  id: z2.number(),
  lastName: z2.string().nullable(),
  phoneNumber: z2.string().nullable(),
  policy: userPolicySchema,
  userProfileUuid: z2.string()
});
const fetchUserProfileResponseSchema = z2.object({
  userProfile: userProfileSchema
});
const loungePassSchema = z2.object({
  imageUrl: z2.string(),
  passCode: z2.string(),
  passengerName: z2.string(),
  validUntil: z2.string()
});
const fetchLoungePassesResponseSchema = z2.object({
  loungePasses: z2.array(loungePassSchema)
});
const postDashboardVisitedResponseSchema = z2.object({});
function postDashboardVisited({ client }) {
  return client.url("/api/v2/user_profiles/dashboard_visited").patch({}).valid(postDashboardVisitedResponseSchema);
}
const postPersonalDetailsProvidedResponseSchema = z2.object({});
function postPersonalDetailsProvided({ client }) {
  return client.url("/api/v2/user_profiles/personal_details_provided").patch({}).valid(postPersonalDetailsProvidedResponseSchema);
}
function fetchConsents({ client }) {
  return client.get("/api/v2/user_profiles/consents").valid(fetchConsentsResponseSchema);
}
function updateConsents({
  client,
  params
}) {
  const payload = consentsSchema.parse(params);
  return client.url("/api/v2/user_profiles/consents").snakeCaseBody(payload).patch().valid(updateConsentsResponseSchema);
}
function fetchUserProfile({ client }) {
  return client.get("/api/v2/user_profiles/me").valid(fetchUserProfileResponseSchema);
}
const fetchLoungePassesRequestSchema = z2.object({
  token: z2.string()
});
function fetchLoungePasses({
  client,
  params
}) {
  const { token } = fetchLoungePassesRequestSchema.parse(params);
  return client.url(`/api/v2/user_profiles/lounge_passes`).query({ token }).get().valid(fetchLoungePassesResponseSchema);
}
function createBaseAhPlusHTTPClient({
  caller: caller$1,
  baseURL,
  options
}) {
  return createHTTPClient({
    baseURL,
    options: {
      credentials: "include",
      ...options
    }
  }).addon(caller).addon(valid()).addon(queryStringAddon).addon(snakeCaseBody()).caller(caller$1);
}
export {
  ActivationStatus,
  i as AirBundleDocumentFile,
  j as AirBundleDocumentParam,
  g as AirBundleRejectionReason,
  c as AirLuggageStatus,
  f as AirPayoutCoverage,
  e as AirPayoutDisruption,
  d as AirPayoutStatus,
  B as BANK_INPUTS,
  C as CheckDeletableReason,
  F as FeatureFlagState,
  I as InsuranceType,
  MembershipTier,
  a as PaymentFrequency,
  h as ProductDisplayName,
  ProductName,
  b as ProductPerk,
  TripTier,
  activateTrip,
  activateTripRequestSchema,
  ah as addJourney,
  ag as addJourneyResponseSchema,
  M as airBundleDocumentUploadSchema,
  O as airBundlePresignedUrlResponseSchema,
  N as airBundlePresignedUrlSchema,
  J as airLuggageJourneysSchema,
  L as airLuggagesTriggerRequestSchema,
  K as airLuggagesUpdateRequestSchema,
  F2 as airPayoutJourneysSchema,
  G as airPayoutRequestSchema,
  I2 as airPayoutsTriggerRequestSchema,
  H as airPayoutsUpdateRequestSchema,
  B2 as airRejectionsSchema,
  R as airlineSchema,
  Q as airportSchema,
  V as bankFieldsSchema,
  _ as billingAddress,
  am as cancelMembership,
  ak as cancelMembershipRequestSchema,
  al as cancelMembershipResponseSchema,
  consentsSchema,
  createBaseAhPlusHTTPClient,
  s as createVerificationSession,
  a7 as deleteJourney,
  a6 as deleteJourneyRequestSchema,
  ac as editableFellowPassengerSchema,
  ab as editableFlightSchema,
  ad as editableItinerarySchema,
  af as editableJourneyRequestSchema,
  ae as editableJourneySchema,
  y as featureFlagSchema,
  P as fellowPassengerSchema,
  aj as fetchAirBundleSubscription,
  ai as fetchAirBundleSubscriptionResponseSchema,
  o as fetchAirLuggageJourneys,
  l as fetchAirLuggageJourneysRequestSchema,
  n as fetchAirLuggageJourneysResponseSchema,
  k as fetchAirPayoutJourneys,
  i2 as fetchAirPayoutJourneysRequestSchema,
  j2 as fetchAirPayoutJourneysResponseSchema,
  ar as fetchBillingManagement,
  $ as fetchBillingManagementSchema,
  a5 as fetchCheckDeletableJourney,
  a4 as fetchCheckDeletableJourneyRequestSchema,
  fetchConsents,
  fetchConsentsResponseSchema,
  d2 as fetchFeatureFlags,
  c2 as fetchFeatureFlagsResponseSchema,
  a1 as fetchJourney,
  a0 as fetchJourneyRequestSchema,
  a3 as fetchJourneys,
  a2 as fetchJourneysResponseSchema,
  fetchLoungePasses,
  fetchLoungePassesRequestSchema,
  fetchLoungePassesResponseSchema,
  h2 as fetchLounges,
  e2 as fetchLoungesRequestSchema,
  g2 as fetchLoungesResponseSchema,
  b2 as fetchOffers,
  a8 as fetchOffersRequestSchema,
  f2 as fetchOffersResponseSchema,
  aq as fetchTrip,
  ap as fetchTripRequestSchema,
  fetchUserProfile,
  fetchUserProfileResponseSchema,
  T as flightSchema,
  S as flightStatusSchema,
  U as itinerarySchema,
  D as journeyCheckDeletableSchema,
  C2 as journeySchema,
  E as journeyWithMetaSchema,
  z as loungeSchema,
  m as makeFetchOffersRoute,
  A as offerSchema,
  Y as payment,
  postDashboardVisited,
  postDashboardVisitedResponseSchema,
  postPersonalDetailsProvided,
  postPersonalDetailsProvidedResponseSchema,
  x as postPromoCode,
  v as postPromoCodeRequestSchema,
  w as postPromoCodeResponseSchema,
  Z as subscription,
  p as triggerAirLuggageJourneys,
  t as triggerAirPayoutJourneys,
  ao as tripResponseSchema,
  an as tripSchema,
  q as updateAirLuggageJourneys,
  u as updateAirPayoutJourneys,
  av as updateBillingAddress,
  au as updateBillingAddressRequestSchema,
  as as updateBillingAddressResponseSchema,
  at as updateBillingAddressSchema,
  updateConsents,
  updateConsentsRequestSchema,
  updateConsentsResponseSchema,
  ax as updateCreditCard,
  aw as updateCreditCardResponseSchema,
  aa as updateJourney,
  a9 as updateJourneyRequestSchema,
  a82 as updateJourneySchema,
  r as uploadAirBundleDocument,
  userPolicySchema,
  userProfileSchema,
  validateActivationToken,
  validateActivationTokenRequestSchema,
  validateActivationTokenResponseSchema,
  X as verificationResponseSchema,
  W as verificationSchema
};
//# sourceMappingURL=index.js.map
